import { Users, Globe, Target, Award, DollarSign } from "lucide-react";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserShield } from "react-icons/fa6";
import { dashboardApi } from "../../Services/ApiServices";

function Dashboard() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({});

  const handleDashboardCount = () => {
    dashboardApi()
      .then(res => {
        console.log(res);
        setDashboardData(res.data.data);
      })
      .catch(err => {
        console.log(err);
        setDashboardData({});
      });
  };


  useEffect(() => {
    handleDashboardCount();
  }, []);


  const data = [
    {
      lable: "Dashboard",
      data: [
        {
          lable: "Total Coachee",
          value: dashboardData?.total_user,
          icon: <Users size={20} className="text-white" />,
          link: "/coachee",
        },
        {
          lable: "Total Coach",
          value: dashboardData?.total_coach,
          icon: <FaUserShield className="w-[20px] h-[20px] text-white" />,
          link: "/coach",
        },
        {
          lable: "Language",
          value: dashboardData?.total_language,
          icon: <Globe size={20} className="text-white" />,
          link: "/language",
        },
        {
          lable: "Coaching Specialities",
          value: dashboardData?.total_specialities,
          icon: <Target size={20} className="text-white" />,
          link: "/coachingspecialities",
        },
        {
          lable: "Coaching Accreditation",
          value: dashboardData?.total_accreditation,
          icon: <Award size={20} className="text-white" />,
          link: "/coachingaccreditation",
        },
        {
          lable: "Currency",
          value: dashboardData?.total_crrency,
          icon: <DollarSign size={20} className="text-white" />,
          link: "/currency",
        },
      ],
    },
  ];

  return (
    <div className="space-y-8">
      {data.map((section, idx) => (
        <div key={idx} className="space-y-5">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-bold text-gray-800">
              {section.lable}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
            {section.data.map((item, i) => (
              <div
                onClick={() => (item.link ? navigate(item.link) : null)}
                key={i}
                className="group relative bg-white rounded-2xl p-8 border border-gray-100 cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-40 h-40 bg-[#2C5BA7] opacity-0 group-hover:opacity-10 rounded-full blur-3xl transition-opacity duration-300"></div>

                <div className="relative z-10 h-full flex flex-col">
                  {/* Top Section - Icon and Arrow */}
                  <div className="flex items-start justify-between mb-auto">
                    <div className="bg-[#2C5BA7] w-14 h-14 flex items-center justify-center rounded-xl shadow-md group-hover:scale-110 group-hover:shadow-lg transition-all duration-300">
                      {item.icon}
                    </div>

                    {/* Arrow in top right */}
                    {item.link && (
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <svg
                          className="w-5 h-5 text-[#2C5BA7] transform group-hover:translate-x-1 transition-transform duration-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </div>
                    )}
                  </div>

                  {/* Bottom Section - Label and Count */}
                  <div className="flex items-end justify-between mt-auto pt-4">
                    <p className="text-base font-semibold text-gray-600 group-hover:text-gray-800 transition-colors duration-300">
                      {item.lable}
                    </p>

                    {/* Count in bottom right */}
                    <p className="text-2xl font-semibold text-gray-600 group-hover:text-gray-800 transition-colors duration-300">
                      {item.value}
                    </p>
                  </div>
                </div>

                <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-[#2C5BA7]/20 transition-all duration-300 pointer-events-none"></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Dashboard;
